import React from "react";
import { GraduationCap, Briefcase, Baby, UserRound, Heart, Sparkles } from "lucide-react";
import { SectionHeading } from "@/components/PackSelection";

const personas = [
  { icon: GraduationCap, label: "Étudiants" },
  { icon: Briefcase, label: "Salariés" },
  { icon: Baby, label: "Parents" },
  { icon: UserRound, label: "Indépendants" },
  { icon: Heart, label: "Passionnés de beauté" },
  { icon: Sparkles, label: "Activité complémentaire" },
];

export const TargetAudience = () => (
  <section id="who" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24 scroll-mt-20">
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
      <div>
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-4">
          Pour qui ?
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl font-medium tracking-tight text-[var(--oz-text)]">
          Une solution pour celles et ceux qui veulent se lancer
        </h2>
        <p className="mt-5 text-base text-[var(--oz-muted)] leading-relaxed">
          Étudiant(e), salarié(e), indépendant(e), parent ou simplement passionné(e) de beauté ?
          Les Packs Ozentya permettent de démarrer avec un niveau d'investissement différent selon
          votre projet.
        </p>
        <div className="mt-6 bg-[var(--oz-nude)]/50 border border-[var(--oz-border)] rounded-2xl p-5 text-sm text-[var(--oz-text)] leading-relaxed">
          Pas besoin de commencer avec le plus gros pack : choisissez simplement la formule adaptée
          à votre situation.
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {personas.map((p, i) => (
          <div
            key={i}
            data-testid={`persona-${i}`}
            className="bg-white rounded-2xl border border-[var(--oz-border)] p-5 flex flex-col items-center text-center gap-3 hover:-translate-y-1 hover:border-[var(--oz-gold)] transition-all"
          >
            <div className="w-11 h-11 rounded-full bg-[var(--oz-bg-2)] flex items-center justify-center text-[var(--oz-gold)]">
              <p.icon className="w-5 h-5" />
            </div>
            <span className="text-xs font-semibold text-[var(--oz-text)] leading-tight">{p.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
